/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface RechercheClasseHoraireRemplacementDefinitiveSearch
 */
export interface RechercheClasseHoraireRemplacementDefinitiveSearch {
    /**
     * 
     * @type {number}
     * @memberof RechercheClasseHoraireRemplacementDefinitiveSearch
     */
    idRemplacement?: number;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheClasseHoraireRemplacementDefinitiveSearch
     */
    classe?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheClasseHoraireRemplacementDefinitiveSearch
     */
    remplacant?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheClasseHoraireRemplacementDefinitiveSearch
     */
    contrat?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof RechercheClasseHoraireRemplacementDefinitiveSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof RechercheClasseHoraireRemplacementDefinitiveSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheClasseHoraireRemplacementDefinitiveSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheClasseHoraireRemplacementDefinitiveSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof RechercheClasseHoraireRemplacementDefinitiveSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RechercheClasseHoraireRemplacementDefinitiveSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the RechercheClasseHoraireRemplacementDefinitiveSearch interface.
 */
export function instanceOfRechercheClasseHoraireRemplacementDefinitiveSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RechercheClasseHoraireRemplacementDefinitiveSearchFromJSON(json: any): RechercheClasseHoraireRemplacementDefinitiveSearch {
    return RechercheClasseHoraireRemplacementDefinitiveSearchFromJSONTyped(json, false);
}

export function RechercheClasseHoraireRemplacementDefinitiveSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): RechercheClasseHoraireRemplacementDefinitiveSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idRemplacement': !exists(json, 'idRemplacement') ? undefined : json['idRemplacement'],
        'classe': !exists(json, 'classe') ? undefined : TextSearchFromJSON(json['classe']),
        'remplacant': !exists(json, 'remplacant') ? undefined : TextSearchFromJSON(json['remplacant']),
        'contrat': !exists(json, 'contrat') ? undefined : TextSearchFromJSON(json['contrat']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function RechercheClasseHoraireRemplacementDefinitiveSearchToJSON(value?: RechercheClasseHoraireRemplacementDefinitiveSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idRemplacement': value.idRemplacement,
        'classe': TextSearchToJSON(value.classe),
        'remplacant': TextSearchToJSON(value.remplacant),
        'contrat': TextSearchToJSON(value.contrat),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

